import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { client } from '../../utils/trpc';
import Error from '../common/Error';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
  ruleId: number;
};
const RuleHistoryModal = t0 => {
  const $ = _c(16);
  const {
    closeHandler,
    ruleId
  } = t0;
  let t1;
  if ($[0] !== ruleId) {
    t1 = {
      queryKey: ["ruleEditHistory", ruleId],
      queryFn: () => unwrapFromResult(client.spaces.ruleEditHistory.query({
        ruleId
      }))
    };
    $[0] = ruleId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isLoading,
    isError,
    data
  } = useQuery(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ModalHeader><h2>Rule History</h2></ModalHeader>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== data || $[4] !== isError || $[5] !== isLoading) {
    t3 = !isLoading && !isError && data && data.edits.length !== 0 && <div>{data.edits.map((item, i) => <div key={item.id} className="rounded-md p-4 hover:bg-background-light"><div className=""><span className="text-lg font-semibold">{data.edits.length - i === 1 ? `Original Rule on ${new Date(item.createdAt).toLocaleDateString()} ${new Date(item.createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit"
            })}` : `Edited on ${new Date(item.createdAt).toLocaleDateString()} ${new Date(item.createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit"
            })}`}</span><p className="text-textSecondary/70">{item.title}</p><span className="text-textSecondary/60">{item.description}</span></div></div>)}</div>;
    $[3] = data;
    $[4] = isError;
    $[5] = isLoading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = isError || data?.edits?.length === 0;
  let t5;
  if ($[7] !== isLoading || $[8] !== t4) {
    t5 = <Error loading={isLoading} error={t4} />;
    $[7] = isLoading;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <ModalContent>{t3}{t5}</ModalContent>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== closeHandler || $[14] !== t6) {
    t7 = <Modal closeHandler={closeHandler}>{t2}{t6}</Modal>;
    $[13] = closeHandler;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default RuleHistoryModal;